/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import platform from '@/shared/utils/platform';
import URLUtils from '@/shared/utils/URLUtils';
import { ubtPage, ubtPageViewOut } from '@/shared/utils/ubt';
import {
  Component, InjectReactive, Prop, Vue,
} from 'vue-property-decorator';
import { HiddenNavigationBarEnum } from '@/enums/navbar';
import isPrerendering from '@/shared/utils/isPrerendering';

import style from './index.module.scss';

@Component
export default class LoadingPage extends Vue {
  @Prop(String) readonly pageId!: string;

  @InjectReactive() isShowH5Nav: boolean | undefined = undefined;

  private mounted() {
    ubtPage(this.pageId, '', Date.now());
  }

  private destroyed() {
    const htmlElem = document.querySelector('html') as HTMLElement;

    // 保障从我的切换到首页时，不在显示loading
    if (htmlElem) {
      htmlElem.setAttribute('show-loading', 'false');
    }

    ubtPageViewOut(this.pageId, '', Date.now());
  }

  private get isAddAppContentPadding() {
    const query = URLUtils.getQueryMap();
    const { hiddenNavigationBar } = query;

    if (this.isShowH5Nav !== undefined) {
      return this.isShowH5Nav;
    }
    // 哈啰 app 内，显示高度
    if (hiddenNavigationBar === HiddenNavigationBarEnum.hiddenNavigationBar
      && platform.isHelloApp) {
      return true;
    }

    // TODO:目前只能先这样处理，没加hiddenNavigationBar参数的会往上滚动, 没定位到原因
    return true;
  }

  private renderAppLoading() {
    return (
      <div class={[
        style.LoadingPage,
        this.isAddAppContentPadding && style.isShowH5Nav,
      ]}
      >
        <div class={style.appRightTop}></div>
        <div class={style.appLeftBottom}></div>
        <div class={style.loadingAppMain}>
          <div class={style.appProgress} />
        </div>

        <div class={style.appTextDes}>
          想用钱<span class={style.appTextDesBold}>就用臻有钱</span>
        </div>
        {this.$slots.default}
      </div>
    );
  }

  private renderH5Loading() {
    return (
      <div class={[
        style.LoadingPage,
        this.isAddAppContentPadding && style.isShowH5Nav,
      ]}
      >
        <div class={style.loadingMain}>
          <div class={style.progress} />
        </div>

        <div class={style.textDes}>
          想用钱就用臻有钱
        </div>

        <div class={style.footer} />
        {this.$slots.default}
      </div>
    );
  }

  private renderPrerenderContent() {
    const initialRoute = window._INITIAL_ROUTE || '';

    // 根据不同的路由展示不同的预渲染内容
    if (initialRoute.startsWith('/v2/home')) {
      // 主入口首页相关路由
      return this.renderAppLoading();
    }

    // if (initialRoute.startsWith('/alimini-home')) {
    //   // 支付宝首页相关路由
    //   return this.renderH5Loading();
    // }

    // 其他路由的默认展示
    return this.renderH5Loading();
  }

  private render() {
    // 预渲染阶段判断
    if (isPrerendering()) {
      return this.renderPrerenderContent();
    }

    // 非预渲染阶段，按原逻辑处理
    if (platform.isHelloApp) {
      return this.renderAppLoading();
    }

    return this.renderH5Loading();
  }
}
